import { z } from 'zod';
import { ErrorCode } from '../../shared/error-codes';
import { EntitySuggestionSchema } from '../../entities/entity-suggestion';
export const MergeEntitySuggestionRequestSchema = z.object({
    targetEntityId: z.string().min(1, ErrorCode.FIELD_REQUIRED)
});
export const MergeEntitySuggestionResponseSchema = z.object({
    data: EntitySuggestionSchema
});

//# sourceMappingURL=merge-entity-suggestion.contract.js.map